/**
 * References from https://github.com/FauzanKhan/angular-query-builder
 */
;(function(angular) {
	'use strict';

	angular
		.module('fauzanKhanQueryBuilder')
		.directive('queryBuilder', ['$compile', 'QBTemplatesFactory', 'QB_CONSTANTS', function($compile, QBTemplatesFactory, QB_CONSTANTS) {
		return {
			restrict: 'EA',
			require: 'ngModel',
			scope: {
				// 'data': '=', // Object in which the query will be reflected
				'columns': '=', //Columns for building query
				// 'operations': '=', //Operations  which are to be applied on columns
				'options': '=?',
			},
			link: function(scope, ele, attr, ctrl) {
				var getTemplates = QBTemplatesFactory.get;
				var buildTemplate = QBTemplatesFactory.build;
				scope.options = angular.extend({
                    expressionValuePrefix: '',
                    jointOperators: ['+', '-', '*', '/', 'AND', 'OR'],
                    showBrackets: true,
					mode: QB_CONSTANTS.FILTER_MODE,
					valueOperators: ['>', '<', '<=', '>=', '==', '=', 'is'],
					allowCustomQuery: QB_CONSTANTS.ALLOW_CUSTOM_QUERY,
				}, scope.options || {});


				//Object template for custom query
				var customQuery = {
					type: 'custom',
					column: '',
					operation: '',
					value: '',
					custom: ''
				};

				//Object template for basic query
				var basicQuery = {
					type: 'basic',
					column: '',
					operation: '',
					value: '',
					custom: ''
				};

				ctrl.$formatters.push(function(modelValue) {
					console.log('ctrl.$formatters');
					if (!modelValue) {
						modelValue = {};
					}
					modelValue.expression = modelValue.expression || null;
					modelValue.operands = modelValue.operands || [angular.copy(basicQuery)]; // if no operands are present then push a basicQuery to oprands array
					modelValue.bracketIds = modelValue.bracketIds || []; //If bracketIds are not present initialize it to an empty array
					return modelValue;
				});

				ctrl.$render = function() {
                    console.log('ctrl.$render');
					scope.query = ctrl.$viewValue;
					init();
				};

				ctrl.$parsers.push(function(viewValue) {
					console.log('ctrl.$parsers');
					return viewValue;
				});

				// scope.query = query;

				// scope.query.expression = scope.query.expression ? scope.query.expression : null;
				// scope.query.operands = scope.query.operands || [angular.copy(basicQuery)]; // if no operands are present then push a basicQuery to oprands array
				// scope.query.bracketIds = scope.query.bracketIds || []; //If bracketIds are not present initialize it to an empty array

				//Hides/shows Popover
				scope.togglePopover = function(event) {
					var isVisible = angular.element(event.target).closest('.popover-parent').hasClass('active');
					angular.element('.popover-parent').removeClass('active');
					if (!isVisible)
						angular.element(event.target).closest('.popover-parent').addClass('active');

					setViewValue();
				};

				//Adds a new Sub Query
				scope.newEntry = function(event) {
					scope.currIndex = parseInt(scope.currIndex);
					scope.currIndex += 1;
					// var currIndex = scope.currIndex;
					scope.query.operands.push(angular.copy(basicQuery));
					var templates = getTemplates(scope.currIndex);
					ele.find('.query-builder-wrapper').append($compile(templates.operator)(scope));
					ele.find('.query-builder-wrapper').append($compile(templates.operandSelection)(scope));
                    setViewValue();
				};

				//Changes type of Sub QUery
				scope.changeQueryType = function(index, queryType) {
					if (queryType == 'basic')
						scope.query.operands[index] = angular.copy(basicQuery);
					else
						scope.query.operands[index] = angular.copy(customQuery);
				};

				//Changes operator between two sub queries
				scope.changeOperator = function(newOperator, event) {
					var operatorWrapper = angular.element(event.target).closest('.operator-wrapper');
					operatorWrapper.find('.operator').text(newOperator);
					operatorWrapper.removeClass('active');
                    setViewValue();
				};

				//Calculates position of brackets and adds them in the DOM
				scope.addBrackets = function(event) {
					var parent = angular.element(event.target).closest('.operator-wrapper');
					var operatorId = parent.attr('data-operator-id');
					var next = parent.next();
					var prev = parent.prev();
					var leftBracket = '<span class="bracket opening-bracket" data-bracket-id="' + operatorId + '">(</span>';
					var rightBracket = '<span class="bracket closing-bracket" data-bracket-id="' + operatorId + '">)</span>';
					// if next element is not an opening bracket then add a bracket
					if (!next.hasClass('bracket opening-bracket')) {
						next.after(rightBracket);
					} else {
						//if next element is a bracket the recursively iterate to the next of next elements
						//counting the no. of opening and closing brackets encountered
						//when they become equal add another colsing bracket 
						next = next.next();
						var openingBracketsCount = 1;
						while (next.length > 0) {;
							if (next.hasClass('bracket opening-bracket')) {
								openingBracketsCount += 1;
							} else if (next.hasClass('bracket closing-bracket')) {
								openingBracketsCount -= 1;
								if (openingBracketsCount == 0) {
									angular.element(next).after(rightBracket);
									break;
								}
							}
							next = next.next();
						}
					}
					// if prev element is not a closing bracket then add a bracket
					if (!prev.hasClass('bracket closing-bracket')) {
						prev.before(leftBracket);
					} else {
						//if prev element is a bracket the recursively iterate to the prev of prev elements
						//counting the no. of opening and closing brackets encountered
						//when they become equal add another opening bracket 
						prev = prev.prev();
						var closingBracketsCount = 1;
						while (prev.length > 0) {
							if (prev.hasClass('bracket closing-bracket')) {
								closingBracketsCount += 1;
							} else if (prev.hasClass('bracket opening-bracket')) {
								closingBracketsCount -= 1;
								if (closingBracketsCount == 0) {
									angular.element(prev).before(leftBracket);
									break;
								}
							}
							prev = prev.prev();
						}
					}
					parent.removeClass('active');
					getBracketIds();
                    setViewValue();
				};

				//Removes brackets corresponding to a sub query
				scope.removeBrackets = function(event) {
					var parent = angular.element(event.target).closest('.operator-wrapper');
					var operatorId = parent.attr('data-operator-id');
					var builderWrapper = parent.closest('.query-builder-wrapper');
					builderWrapper.find('.bracket[data-bracket-id="' + operatorId + '"]').remove();
					parent.removeClass('active');
					getBracketIds();
                    setViewValue();
				};

				function init() {
                    var currIndexTemp = scope.query.expression ? scope.query.expression.match(/[^A-Za-z()]/g) : 0;
                    scope.currIndex = scope.query.expression ? currIndexTemp[currIndexTemp.length - 1] : 0; // currIndex refers to the index of last sub query

                    ele.append('<div class="query-builder-wrapper"></div>');
                    ele.append('<div class="add-sub-query"></div>');
                    ele.find('.add-sub-query').append($compile(getTemplates(0).addMoreBtn)(scope));
                    if (!scope.query.expression) {
                        ele.find('.query-builder-wrapper').append($compile(getTemplates(0).operandSelection)(scope));
                    } else {
                        buildTemplate(ele, scope.query.expression, scope.query.operands, scope.query.bracketIds, scope);
                    }
                    angular.element('.query-builder-wrapper').on('click', '.popover-parent', function (e) {
                        e.stopPropagation();
                    });
                    angular.element('body').on('click', function () {
                        angular.element('.query-builder-wrapper .popover-parent').removeClass('active');
                    });
                }

                // scope.query.expression = buildExpression();

				function setViewValue() {
                    scope.query.expression = buildExpression();
					ctrl.$setViewValue(scope.query);
				}


                //Gets the data-bracket-Ids of current brackets in the DOM
                function getBracketIds() {
                    var brackets = ele.find('.query-builder-wrapper').find('.bracket');
                    var temp = [];
                    for (var i = 0; i < brackets.length; i++) {
                        var bracketId = angular.element(brackets[i]).attr('data-bracket-id');
                        temp.push(parseInt(bracketId));
                    }
                    scope.query.bracketIds = temp;
                }

                //Builds an expression corresponding to current query
                function buildExpression() {
                    var expression = [];
                    var temp = angular.element('.query-builder-wrapper').children();
                    for (var i = 0; i < temp.length; i++) {
                        var elem = angular.element(temp[i]);
                        var eleText = elem.text();
                        if (elem.hasClass('bracket')) {
                            expression.push(eleText);
                        } else if (elem.hasClass('operator-wrapper')) {
                            eleText = elem.find('.operator').text();
                            expression.push(eleText);
                        } else {
                            var opererand_index = elem.attr('data-opererand-id');
                            var opererand = scope.query.operands[parseInt(opererand_index)];
                            expression.push(scope.options.expressionValuePrefix + opererand.column.identifier);
                        }
                    }
                    return expression.join(' ');
                }
			}
		}
	}]);
})(angular);